import { Box, Table, TableBody, TableContainer } from "@material-ui/core";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import CssPagination from "src/components/Pagination/CssPagination";
import Empty from "src/components/utils/Empty";
import { useTransactionMonitoringSelector } from "src/context/monitoring/transactionMonitoringContext";
import usePagination from "src/hooks/usePagination";
import useSortData from "src/hooks/useSortData";
import TransactionHeader from "./TransactionHeader";
import TransactionRow from "./TransactionRow";

export default function TransactionLog() {
  const { pool } = useParams();
  const transactionData = useTransactionMonitoringSelector((state) => {
    const transactionData = state.transactionData;
    return transactionData?.[pool];
  });

  const tableData = useMemo(() => {
    if (transactionData?.data) return transactionData.data;
    return [];
  }, [transactionData]);

  const { update, data: sortData, sortType, sortKey } = useSortData(tableData, "desc", "amount");
  const { data, jump, maxPage, currentPage } = usePagination(sortData);

  return (
    <Box>
      <TableContainer style={{ borderRadius: "10px" }}>
        <Table>
          <TransactionHeader sortUpdate={update} sortType={sortType} sortKey={sortKey} />
          <TableBody>
            {data?.map((element, index) => {
              return <TransactionRow key={index} rowData={element} />;
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {tableData.length === 0 && (
        <Box width="100%" display="flex" justifyContent="center">
          <Empty title="No Transaction Found!" iconProps={{ style: { fontSize: "60px" } }} />
        </Box>
      )}
      {data.length > 0 && (
        <CssPagination
          mt={1}
          paginationProps={{ page: currentPage, count: maxPage, onChange: (_, page) => jump(page) }}
        />
      )}
    </Box>
  );
}
